import type { MatchMethod } from '../types/product-master.api.types';
import type { RunProductOutcome } from '../types/run-detail.api.types';

import type { ProductMasterSearch } from './product-master-search';

/**
 * Search params for `/catalog-enrichment/products` that drill into one curation outcome
 * of a run (`curatedInRun` + `outcome`, the pair `GET /catalog-products` takes).
 * Typed by the product-master route's own search schema, so a renamed key fails the build.
 * Review fix — `matchMethod` carries a MATCHED_EXISTING drill-down's active method filter through
 * (the schema only honours it alongside that outcome; see `product-master-search.ts`), so "Open in
 * Products ↗" from a method-filtered sheet lands on the SAME filtered list, not the whole outcome.
 */
export function runOutcomeSearch(
  runId: string,
  outcome: RunProductOutcome,
  matchMethod?: MatchMethod | null,
): ProductMasterSearch {
  return { curatedInRun: runId, outcome, ...(matchMethod ? { matchMethod } : {}) };
}
